export default "__VITE_ASSET__DR5uzN7K__"